import { defineStore } from 'pinia';
import api from '@/services/api';
import talonario_model from '@/shared/models/talonario_model';
import { getParamsUrl } from './talonario_utils';

export const useTalonarioStore = defineStore('talonarioStore', {
  state: () => ({
    entity: 'talonario',
    talonarios: [],
    talonario: { ...talonario_model },
    page: 1,
    filters: {},
  }),
  getters: {},
  actions: {
    async findAllTalonarioHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, Activo: true, ...this.filters, ...params })}`,
      );
      if (result && result.data.length > 0) {
        this.talonarios.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async saveTalonario() {
      if (this.talonario.Codigo) {
        return await this.updateTalonarioHTTP();
      } else {
        return await this.createTalonarioHTTP();
      }
    },
    async createTalonarioHTTP() {
      return await api.post(`/${this.entity}`, this.talonario);
    },
    async updateTalonarioHTTP() {
      return await api.patch(`/${this.entity}/${this.talonario.Codigo}`, this.talonario);
    },
    async deleteTalonarioHTTP(talonario) {
      return await api.patch(`/${this.entity}/${talonario.Codigo}`, {
        ...talonario,
        Activo: false,
      });
    },
    cleanTalonario() {
      this.talonario = { ...talonario_model };
    },
    setPage(page) {
      this.page = page;
    },
    async firstRequest() {
      this.setPage(1);
      this.emptyList();
      await this.findAllTalonarioHTTP();
    },
    emptyList() {
      this.talonarios = [];
    },
  },
});
